import { MAIN_ROUTES_CONFIG, MainRouteKeys, useGet2ndLevelPageUrl } from 'app-level/navigation';
import { useFeatureFlag } from 'context/FeatureFlagContext';
import { matchPath, useLocation } from 'react-router-dom';
import { getStringAsKeyOf } from 'utils/typeUtils';

import { SUB_HEADER_CONFIGS } from './headers.config';

export interface SubHeaderTab {
  key: string;
  label: string;
  to: string;
  activePath: string;
  disabled?: boolean;
}

export function isTabActive(tab: SubHeaderTab, pathname: string): boolean {
  return !!tab.activePath && !!matchPath({ path: tab.activePath, end: false }, pathname);
}

export function useSubHeaderTabs(): { mainRouteKey: MainRouteKeys; tabs: SubHeaderTab[] } | null {
  const getUrl = useGet2ndLevelPageUrl();
  const isRemittanceEnabled = useFeatureFlag('remittance');
  const mainSegment = useLocation().pathname.split('/')[1];
  if (!mainSegment) return null;

  const mainRouteKey = getStringAsKeyOf(MAIN_ROUTES_CONFIG, mainSegment.toLowerCase());
  if (!mainRouteKey) return null;

  const subHeadersConfig =
    mainRouteKey === 'portfolio' && isRemittanceEnabled
      ? [
          ...SUB_HEADER_CONFIGS[mainRouteKey],
          {
            routeKey: 'remittance',
            label: 'Remittance',
            iconName: 'remittance',
          },
        ]
      : SUB_HEADER_CONFIGS[mainRouteKey];

  return {
    mainRouteKey,
    tabs: subHeadersConfig.map((config) => {
      const to = config.routeKey ? `/${mainSegment}/${getUrl(mainRouteKey, config.routeKey)}` : '';
      const activeMatch = 'activeMatch' in config ? config.activeMatch : undefined;
      return {
        key: config.routeKey ?? config.label,
        label: config.label,
        to,
        activePath: activeMatch ? `/${mainSegment}/${activeMatch}` : to.split('?')[0],
        disabled: config.disabled,
      };
    }),
  };
}
